import React from 'react';
import { Box, Typography, Button, useTheme } from '@mui/material';
import { LockOutlined } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

const AccessDenied = ({ message }) => {
  const navigate = useNavigate();
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '60vh',
        gap: 2,
        textAlign: 'center',
        p: 4,
      }}
    >
      <LockOutlined sx={{ fontSize: 72, color: theme.palette.error.main, opacity: 0.8 }} />
      <Typography variant="h4" fontWeight={700} color="text.primary">
        Access Denied
      </Typography>
      <Typography variant="body1" color="text.secondary" sx={{ maxWidth: 420 }}>
        {message || "You don't have permission to view this page. This event may not belong to you or may no longer be shared with you."}
      </Typography>
      <Button
        variant="contained"
        color="primary"
        onClick={() => navigate('/home')}
        sx={{ mt: 2, borderRadius: 2, px: 4, py: 1.2, fontWeight: 600 }}
      >
        Go to Home
      </Button>
    </Box>
  );
};

export default AccessDenied;
